import { Net } from './net';

export interface UrlTranslation {
    newUrl: string;
    startUrl: string;
}

export class GatewayUrlTranslator {
    private static translations = {
        powerShellTranslationMatcher: /features\/powershellApi\/(.*)/i,
        cimTranslationMatcher: /features\/cim\/(.*)/i,
        wdacMatcher: /features\/wdac\/(.*)/i,
        jeaMatcher: /features\/jea\/(.*)/i,
        fileTransferMatcher: /features\/fileTransfer\/(.*)/i,
        counterMatcher: /counter\/(.*)/i,
        extensionsTranslationMatcher: /features\/extensions\/(.*)/i
    };
    /**
     * Given url return a gateway v2 translation object that will work well with
     * nodes/node api.
     *
     * @param url a gateway v1 url
     * @returns
     */
    public static translate(url: string): UrlTranslation {
        if (this.translations.powerShellTranslationMatcher.test(url)) {
            return this.translatePowerShellRequest(url);
        }

        if (this.translations.cimTranslationMatcher.test(url)) {
            return this.translateCimRequest(url);
        }

        if (this.translations.jeaMatcher.test(url)) {
            return this.translateJeaRequest(url);
        }

        if (this.translations.wdacMatcher.test(url)) {
            return this.translateWdacRequest(url);
        }

        if (this.translations.fileTransferMatcher.test(url)) {
            return this.translateFileTransferRequest(url);
        }

        if (this.translations.counterMatcher.test(url)) {
            return this.translateCounterRequest(url);
        }

        if (this.translations.extensionsTranslationMatcher.test(url)) {
            return this.translateExtensionsRequest(url);
        }

        return null;
    }

    private static translatePowerShellRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.powerShellTranslationMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerPowerShell}`
            };
        }

        return null;
    }

    private static translateCimRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.cimTranslationMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerCim}`
            };
        }

        return null;
    }

    private static translateJeaRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.jeaMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerJea}`
            };
        }

        return null;
    }

    private static translateFileTransferRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.fileTransferMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerFileTransfer}`
            };
        }

        return null;
    }

    private static translateWdacRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.wdacMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerWdac}`
            };
        }

        return null;
    }

    private static translateCounterRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.counterMatcher);
        if (matches) {
            const restOfString = matches[1];
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerPerformanceCounter}`
            };
        }

        return null;
    }

    private static translateExtensionsRequest(url: string): UrlTranslation {
        const matches = url.match(this.translations.extensionsTranslationMatcher);
        if (matches) {
            const restOfString = `extensions/${matches[1]}`;
            return {
                newUrl: restOfString,
                startUrl: `services/${Net.serviceWinRest}/${Net.controllerExtensions}`
            };
        }

        return null;
    }
}
